import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { LanguageService, TranslatedLanguage, LanguagesPainelSearch } from './language.service';

@Injectable()
export class InternationalizationService {

  constructor(
    private http: HttpClient,
    public translate: TranslateService,
    public language: LanguageService,
    public languageService: TranslateService) {
  }

  get onLangChange(): EventEmitter<LangChangeEvent> {
    return this.languageService.onLangChange;
  }

  changeLanguage(lang: TranslatedLanguage) {
    this.translate.use(lang.code);
  }

  getLanguages(): Promise<TranslatedLanguage[]> {
    return this.http.get(environment.apiURL + '/international/getLanguages')
      .toPromise()
      .then(response => {
        return response as Array<TranslatedLanguage>;
      })
      .catch(error => {
        return null;
      });
  }

  getLanguagesParams(params: LanguagesPainelSearch): Promise<TranslatedLanguage[]> {
    return this.http.post(environment.apiURL + '/international/getLanguages', params)
      .toPromise()
      .then(response => {
        return response as Array<TranslatedLanguage>;
      })
      .catch(error => {
        return null;
      });
  }
}
